import api, { ApiResponse } from "../api";
import { HubGroupDto, HubGroupRequest } from "./models";

const BASE = "/hub-groups";

class HubGroupsService {
  private static instance: HubGroupsService;

  private constructor() {}

  static getInstance(): HubGroupsService {
    if (!HubGroupsService.instance) {
      HubGroupsService.instance = new HubGroupsService();
    }
    return HubGroupsService.instance;
  }

  public listHubGroups = async (): Promise<ApiResponse<HubGroupDto[]>> => {
    return await api.get(BASE);
  };

  public getHubGroup = async (id: string): Promise<ApiResponse<HubGroupDto>> => {
    return await api.get(`${BASE}/${id}`);
  };

  public createHubGroup = async (
    request: HubGroupRequest
  ): Promise<ApiResponse<HubGroupDto>> => {
    return await api.post(BASE, request);
  };

  public updateHubGroup = async (
    id: string,
    request: HubGroupRequest
  ): Promise<ApiResponse<HubGroupDto>> => {
    return await api.put(`${BASE}/${id}`, request);
  };

  public deleteHubGroup = async (id: string): Promise<ApiResponse<void>> => {
    return await api.delete(`${BASE}/${id}`);
  };
}

export default HubGroupsService;
